import React, { FC } from 'react';
import { SearchFiltersRadioIcon } from '../../../search-filters-radio/SearchFiltersRadioIcon';
import { SearchFiltersRadio } from '../../../search-filters-radio/SearchFiltersRadio';

type Props = {
  selected: boolean;
  handleClick?: () => void;
};

export const PartiesSelector: FC<Props> = ({
  children,
  selected,
  handleClick,
}) => {
  return (
    <SearchFiltersRadio
      {...(handleClick
        ? {
            onClick: handleClick,
          }
        : {})}
    >
      <SearchFiltersRadioIcon isSelected={selected} />
      {children}
    </SearchFiltersRadio>
  );
};
